export const wait = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export const formatTimestamp = (timestamp: string): string => {
  const messageDate = new Date(timestamp)
  const now = new Date()
  const diff = now.getTime() - messageDate.getTime()
  const minutes = Math.floor(diff / 60000)

  if (minutes < 1) return 'Just now'
  if (minutes < 60) return `${minutes}m ago`

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`

  return messageDate.toLocaleDateString()
}
